export default "/images/vendor/flag-icons/flags/1x1/co.svg?650be7bf6524161dd3fbf6715ac19867";